import { Checkbox, CollectionPrinter, Div, MultilineInput, Snack, TableBuilder, TextInput } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Center } from "../Components/Center";
import { JobOfferDescriptionEntry } from "../Models/JobOfferDescriptionEntry";
import { JobOfferQuestionEntry } from "../Models/JobOfferQuestionEntry";
import { JobOffer } from "../Models/JobOffer";
import { Page } from "./Page";
import { DangerButton } from "../Components/DangerButton";
import { Swaper } from "../Components/Swaper";
import { OffersRepo } from "../Services/OffersRepo";
import { Panel } from "../Components/Panel";


export class AdminOfferEditPage extends Page
{
    constructor(private _offers: OffersRepo, private offerId: string)
    {
        const shortId = offerId.slice(-6).toUpperCase();

        super("Edycja oferty #" + shortId);

        this.Content(async () =>
        {
            const offer = await this._offers.Get(this.offerId);

            this.body.Append(
                new Panel("Stanowisko", [
                    new TextInput(offer.Title).Placeholder("Nazwa stanowiska"),
                    "\n\n",
                    new Checkbox(offer.IsRecruitmentOpen, "Rekrutacja otwarta"),
                ]),

                new Panel("Opis oferty", [
                    new TableBuilder(offer.Description)
                        .AddColumn("", x => [
                            new Div().Style("display: flex; margin-bottom: 12px; align-items: center; justify-content: space-between;").Append(
                            new TextInput(x.Label),
                            new Swaper(offer.Description, x),
                            ),
                            new MultilineInput(x.Text).Rows(8),
                        ])
                        .Build(),
                    new PrimaryButton("➕ Dodaj pole").OnClick(() => offer.Description.Add(new JobOfferDescriptionEntry())),
                ]),
                new Panel("Pytania do kandydata", [
                    new CollectionPrinter(offer.Form, x =>
                        new Div().Style("display: flex; margin-bottom: 12px; align-items: center; justify-content: space-between;").Append(
                            new TextInput(x.Question),
                            new Swaper(offer.Form, x),
                        )),
                    new PrimaryButton("➕ Dodaj pytanie").OnClick(() => offer.Form.Add(new JobOfferQuestionEntry())),
                ]),
                new Center(
                    new DangerButton("Zapisz", () => this.SaveOffer(offer))
                )
            )
        });
    }

    private async SaveOffer(offer: JobOffer): Promise<void>
    {
        try
        {
            await this._offers.Update(offer);

            new Snack("✅ Oferta zaktualizowana");
        }
        catch (ex: any)
        {
            new Snack("❌ Błąd zapisywania oferty", ex.message);
        }
    }
}
